export const PRODUTO_ATUALIZA_PRODUTOS = 'produto_atualizaProdutos';
export const PRODUTO_RESET_PRODUTOS = 'produto_resetProdutos';
